import type { IOrderItem } from '~/modules/order-analytic';
import type { GTooltipCardProps } from '~/presentation/ui';

import { IVariantType } from '~/modules/campaign/types';

export enum EReportDataType {
  DATE = 'DATE',
  ARRAY = 'ARRAY',
  OBJECT = 'OBJECT',
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  CURRENCY = 'CURRENCY',
  PERCENT = 'PERCENT',
  DURATION = 'DURATION',
  MONTH = 'MONTH_TIMESTAMP',
  QUARTER = 'QUARTER_TIMESTAMP',
  DAY = 'DAY_TIMESTAMP',
  WEEK = 'WEEK_TIMESTAMP',
  YEAR = 'YEAR_TIMESTAMP',
  HOUR = 'HOUR_TIMESTAMP',
}

export interface IReportColumn {
  name: string;
  tooltipCardProps?: Omit<GTooltipCardProps, 'children'>;
  displayName: string;
  dataType: EReportDataType;
}

export type ReportPrimitiveValueType = string | number | null;
export type ReportValueType = ReportPrimitiveValueType | IOrderItem;
export type ReportRowType<T = ReportValueType> = Record<string, T | undefined>;

export interface IReportTable<T = ReportValueType> {
  columns: IReportColumn[];
  rows: ReportRowType<T>[];
}

export enum IRVariantType {
  ALL = 'all',
  VARIANT_A = IVariantType.VARIANT_A,
  VARIANT_B = IVariantType.VARIANT_B,
}
